// minimap-graph-changed.ts — relay for the 'minimap_graph_changed' campaign frame (owner 2026-09-10:
// the encounter mini-map is browser-owned). The map's store lives in the encounter-minimap bundle
// (post-template-tail), so this bundle only re-emits the frame as a window event; the store merges a
// reveal in place or replaces its graph with a pushed full rebuild.

import type { WSMessage } from './types';

type MinimapGraphChangedFrame = Extract<WSMessage, { type: 'minimap_graph_changed' }>;

export function handleMinimapGraphChanged(parsedData: MinimapGraphChangedFrame): void {
    const campaignId = String(parsedData?.campaign_id ?? '').trim();
    if (!campaignId) return;
    window.dispatchEvent(new CustomEvent('ft:minimap-graph-changed', {
        detail: {
            campaignId,
            reason: String(parsedData.reason ?? ''),
            rev: typeof parsedData.rev === 'number' ? parsedData.rev : undefined,
            reveal: parsedData.reveal ?? null,
            graph: parsedData.graph ?? null,
        },
    }));
}
